// extracted by mini-css-extract-plugin
export default {"root":"LiveSearchTypes_root__DwydA","checkboxes":"LiveSearchTypes_checkboxes__YOEyv"};